module.exports = __webpack_public_path__ + "img/textile_design.d4074932.jpg";